// src/components/layout.js
import React from "react"
import Header from "./Header/Header"
import Footer from "./Footer/Footer"
import GlobalStyles from "../assets/styles/GlobalStyles"
import {navigate} from "gatsby";
import ScrollTopButton from "../function/ScrollTopButton"
import Organization from "../micromarkup/Organization"
import OnlineStore from "../micromarkup/OnlineStore"
import Products from "../micromarkup/Products"
import Series from "../micromarkup/Series"
import Article from "../micromarkup/Article" 
import AboutPage from "../micromarkup/AboutPage"

const Layout = ({ children, props  }) => {

    // const getData = props.pageContext === {} && true : false ;
    const getDataPageContext = props?.pageContext;
    const dataKey = props?.location.key;

    const templateName = props.pageContext?.templateFix || props.pageContext?.template?.templateName;

    // Функція для визначення класу шаблону сторінки
    const getTemplateClass = () => {
        if (Object.keys(getDataPageContext).length  === 0) {
            return "page404";
        } else {
            return templateName
        }
        // return templateName || "customPage";
    };

    const templateClass = getTemplateClass();


    const closePopInform = (op) => {
        if ( typeof document !== 'undefined' ) {
            if ( op === 'go' ) {
                // const button = typeof document !== 'undefined' && document.getElementById('showPop');
                const popInform = document.getElementById('popInform');
                popInform.classList.remove('active');

                const popInformGo = document.getElementById('popInformGo');
                const goAttributeValue = popInformGo.getAttribute('go');
                if ( goAttributeValue === 'cart' ) {
                    // console.log('cart >>>>>>>>', goAttributeValue)
                    // navigate(goAttributeValue)
                    document.getElementById('openCart').click();
                }
                if ( goAttributeValue === 'wishlist' ) {
                    // console.log('wishlist >>>>>>>>', goAttributeValue)
                    navigate('/wishlist/')
                    // document.getElementById('openCart').click();
                }

                if ( goAttributeValue === 'login' ) {
                    // console.log('login >>>>>>>>', goAttributeValue)
                    // navigate('/wishlist/')
                    document.getElementById('openAccountActive').click();
                }


            } else {
                const popInform = document.getElementById('popInform');
                popInform.classList.remove('active');


            }
        }
    }
    //
    // function closePopInform() {

    // }


    // console.log('layout >>>>>>>>>', getDataPageContext )

    return (
        // <SmoothScroll>
        <div
            className={`body template-${templateClass} ${
                templateClass === 'page404' ? 'colorRevers' : ''
            }`}
        >
            <div id="scrollProgress" className="level1"></div>
            <GlobalStyles />
            <div className="container">
                <div className="wrapMain border-ver">
                    <Header isFrontPage={getDataPageContext.isFrontPage} colorRevers={templateClass === 'page404' ? 'colorRevers' : 'colorNormal'} />
                    <div className='main'>
                        {children}
                    </div>
                </div>
            </div>

            {/*{*/}
            {/*    console.log('props seoText >>>>>>>>>>>>', children )*/}
            {/*}*/}

            {getDataPageContext?.seoText?.seoActive ? (
                <div className="container">
                    <div className={`WrapDesc WrapFooterItem style-2`}>
                        <div className="row">
                            <div className="col-12 col-lg-5 col-xl-auto">
                                <div className='text st1 fw-3'>
                                    {getDataPageContext?.seoText?.seoTitle}
                                </div>
                            </div>
                            <div className="col-12 col-lg-7 col-xl">
                                <div className='wrapScroll'>
                                    <div className='st4 tc3 desc fw-3' dang erouslySetInnerHTML={{ __html: getDataPageContext?.seoText?.seoText }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : '' }

            {/*{templateClass === 'page404' ? null : (*/}
            {/*    */}
            {/*)}*/}

            <Footer isFrontPage={getDataPageContext?.isFrontPage} />

            <div id='popInform' className='popInform anim' type=''>
                <div className="container">
                    <div className="wrap row row-0">
                        <div className="col-12 col-lg-4">
                            <div id='popInformTitle' className='title st3'> </div>
                        </div>
                        <div className="col-sm">
                            <div className='text st5' id='popInformText'>

                            </div>
                        </div>
                        <div className="col-sm-auto d-flex align-items-center">
                            <div className="wrapBtn">
                                    <span id='popInformGo' go='' onClick={()=>closePopInform('go')} className="btn btn6">

                                    </span>
                            </div>
                            <span className="iconBG icon24 iconBG20" onClick={()=>closePopInform()} />
                        </div>
                    </div>
                </div>
            </div>

            <ScrollTopButton />

            {!["blog", "post", "Account"].includes(getDataPageContext?.templateFix) && (
                <Organization />
            )}

            {!["blog", "post", "Account"].includes(getDataPageContext?.templateFix) && (
                <OnlineStore />
            )}

            {getDataPageContext?.templateFix === "product" && (
                <Products {...props} />
            )}

            {/*{*/}
            {/*    console.log('props >>>>>>>>>>', getDataPageContext.slug )*/}
            {/*}*/}
            {/*templateFix === "categoriesProduct" && typePage === "series"*/}

            {getDataPageContext?.templateFix === "product" && getDataPageContext?.typePage === "series" && (
                <Series {...props} />
            )}

            {getDataPageContext?.templateFix === "post" && (
                <Article {...props} />
            )}

            {getDataPageContext?.slug === "about-us" && (
                <AboutPage {...props} />
            )}

        </div>
        // </SmoothScroll>
    );
}

export default Layout;